const url = "http://search.piar.ee/api";

export { url };
